import { realAxiosInstance } from './api'

export const getReferral = (quoteGuid: string) => {
  return realAxiosInstance.get(`/broker/referral/${quoteGuid}`)
}
